import { render, staticRenderFns } from "./modifyOrderPrice.vue?vue&type=template&id=f0f671fc&scoped=true"
import script from "./modifyOrderPrice.vue?vue&type=script&lang=js"
export * from "./modifyOrderPrice.vue?vue&type=script&lang=js"
import style0 from "./modifyOrderPrice.vue?vue&type=style&index=0&id=f0f671fc&prod&lang=less&scoped=true"
import style1 from "./modifyOrderPrice.vue?vue&type=style&index=1&id=f0f671fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f671fc",
  null
  
)

export default component.exports